import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const Contact = () => {
  return (
    <>
      <Navigation />
      <main className="main-content">
        <div className="page-container">
          <div className="container">
            <h1>Contact Us</h1>
            <div className="contact-info">
              <p>Have questions or need assistance? We're here to help!</p>
              <div className="contact-details">
                <p><strong>Email:</strong> <a href="mailto:mail@aumlaut.dk">mail@aumlaut.dk</a></p>
                <p><strong>Response Time:</strong> Within 24 hours</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer /></>
  );
};

export default Contact;
